module.exports = __webpack_public_path__ + "static/media/ic-download-selected.fb9797b3.svg";